import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Paragraph from '@polestar/component-warehouse-react/components/paragraph/Paragraph';
import { responsiveStyles } from '@polestar/component-warehouse-react/helpers/responsiveStyle';
import { createCSSTransition, MotionDurations, MotionEasings, } from '@polestar/component-warehouse-react/tokens/motion/Motion';
import Icon, { IconSizes } from '@polestar/component-warehouse-react/components/icon/Icon';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import * as Icons from '@polestar/component-warehouse-react/tokens/icons/Icons';
export var InfoPanelVariants;
(function (InfoPanelVariants) {
    InfoPanelVariants["note"] = "note";
    InfoPanelVariants["warning"] = "warning";
})(InfoPanelVariants || (InfoPanelVariants = {}));
const InfoPanel = forwardRef(({ children, title, variant = InfoPanelVariants.note, ...props }, ref) => (React.createElement(Container, { ...props, ref: ref },
    React.createElement(Title, { panelVariant: variant },
        variant == InfoPanelVariants.warning && (React.createElement(WarningIcon, { icon: Icons.warning, size: IconSizes.small })),
        title),
    React.createElement(Wrapper, null, children))));
InfoPanel.displayName = 'InfoPanel';
export default InfoPanel;
const Container = styled.div(({}) => css `
    width: 100%;
    height: 100%;
  `);
Container.displayName = `Container`;
const Wrapper = styled.div(({ theme }) => css `
    transition: ${createCSSTransition('padding', MotionEasings.default, MotionDurations.fast)};

    ${responsiveStyles({
    padding: theme.infoPanel.children.padding,
})};
  `);
const WarningIcon = styled(Icon)(({}) => css `
    margin-inline-end: ${Spacings.xSmall};
    vertical-align: middle;
  `);
const Title = styled(Paragraph)(({ theme, panelVariant }) => css(css `
      transition: ${createCSSTransition('padding', MotionEasings.default, MotionDurations.fast)},
        ${createCSSTransition('background-color', MotionEasings.default, MotionDurations.fast)};
      ${responsiveStyles({
    padding: theme.infoPanel.title.padding,
    marginBlockEnd: theme.infoPanel.title.marginBottom,
})}
      color: ${theme.infoPanel.title[panelVariant].color};
    `, css `
      background-color: ${theme.infoPanel.title[panelVariant].backgroundColor};
    `));
